const AddFileManager = () => {
  return <div>AddFileManager</div>;
};

export default AddFileManager;
